


import React from "react";
import { Link, useLocation } from "react-router-dom";

const SPECS_CURSOR = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='28' viewBox='0 0 48 28'%3E%3Crect x='1' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Crect x='29' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Cpath d='M19 13 L29 13' stroke='%231a1a1a' stroke-width='2.5' stroke-linecap='round'/%3E%3Cpath d='M1 13 L0 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M47 13 L48 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E`;

const navStyle = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');

  body { padding-top: 90px; }

  @keyframes fadeDown {
    from { opacity: 0; transform: translateY(-8px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .nav-root {
    position: fixed;
    top: 0; left: 0; right: 0;
    z-index: 90;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 44px 16px;
    background-color: #fafafa;
    background-image:
      linear-gradient(rgba(0,0,0,0.045) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,0,0,0.045) 1px, transparent 1px);
    background-size: 32px 32px;
    font-family: 'DM Sans', sans-serif;
  }

  .nav-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .nav-name {
    font-size: 11.5px; font-weight: 700;
    letter-spacing: 0.16em; text-transform: uppercase;
    color: #1a1a1a; text-decoration: none;
    transition: opacity 0.15s;
  }
  .nav-name:hover { opacity: 0.6; }

  .nav-role {
    font-size: 10.5px; letter-spacing: 0.1em;
    text-transform: uppercase; color: #888; font-weight: 400;
  }
  .nav-location {
    font-size: 10.5px; letter-spacing: 0.1em;
    text-transform: uppercase; color: #bbb; font-weight: 400;
  }

  /* desktop right links */
  .nav-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 7px;
  }

  .nav-item {
    font-size: 11px; font-weight: 600;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: #1a1a1a; text-decoration: none;
    opacity: 0.55; transition: opacity 0.15s;
    position: relative;
  }
  .nav-item:hover { opacity: 1; }
  .nav-item.active { opacity: 1; }
  .nav-item.active::after {
    content: '';
    position: absolute; bottom: -2px; left: 0; right: 0;
    height: 1.5px; background: #1a1a1a; border-radius: 2px;
  }

  /* hamburger button — hidden on desktop */
  .nav-hamburger {
    display: none;
    background: none;
    border: 1px solid rgba(0,0,0,0.12);
    border-radius: 8px;
    padding: 7px 9px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
  }

  /* mobile dropdown */
  .nav-mobile-menu {
    position: fixed;
    top: 70px; left: 0; right: 0;
    z-index: 89;
    background: rgba(250,250,250,0.98);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(0,0,0,0.07);
    padding: 8px 0 16px;
    animation: fadeDown 0.2s ease both;
  }
  .nav-mobile-item {
    display: block;
    padding: 13px 24px;
    font-size: 12px; font-weight: 600;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: #888; text-decoration: none;
    border-bottom: 1px solid rgba(0,0,0,0.04);
    transition: color 0.15s, background 0.15s;
  }
  .nav-mobile-item:hover { color: #1a1a1a; background: rgba(0,0,0,0.02); }
  .nav-mobile-item.active { color: #1a1a1a; font-weight: 700; }

  /* ── MOBILE breakpoint ── */
  @media (max-width: 640px) {
    .nav-root    { padding: 14px 20px; align-items: center; }
    .nav-right   { display: none; }          /* hide desktop links */
    .nav-hamburger { display: flex; }        /* show hamburger */
    .nav-name    { font-size: 10px; letter-spacing: 0.1em; }
    .nav-role, .nav-location { font-size: 9px; }
    body { padding-top: 70px; }
  }

  @media (min-width: 641px) and (max-width: 900px) {
    .nav-root  { padding: 16px 28px; }
    .nav-item  { font-size: 10px; }
  }
`;

const NAV_ITEMS = [
  { label: "Work",       to: "/",           external: false },
  { label: "About",      to: "/about",      external: false },
  // { label: "Playground", to: "/playground", external: false },
  { label: "Resume",     href: "/resume.pdf", external: true },
  { label: "Contact",    to: "/#contact",   external: false },
];

export default function Navbar() {
  const location = useLocation();
  const [open, setOpen] = React.useState(false);

  const close = () => setOpen(false);

  return (
    <>
      <style>{navStyle}</style>

      <nav className="nav-root">

        {/* LEFT */}
        <div className="nav-left">
          <Link to="/" className="nav-name" onClick={close}>
            Satish Dandabathula
          </Link>
          <span className="nav-role">UI/UX Designer · B2B SaaS</span>
          <span className="nav-location">India</span>
        </div>

        {/* RIGHT — desktop */}
        <div className="nav-right">
          {NAV_ITEMS.map(({ label, to, href, external }) =>
            external ? (
                       <a
  href="/resume.pdf"
  download="Satish-Dandabathula-UIUX-Designer-Resume.pdf"
  className="nav-item"
>
  Resume
</a>
              
            ) : (
              <Link
                key={label}
                to={to}
                className={"nav-item" + (location.pathname === to.split("#")[0] ? " active" : "")}
              >
                {label}
              </Link>
            )
          )}
        </div>

        {/* HAMBURGER — mobile only, shown via CSS */}
        <button
          className="nav-hamburger"
          onClick={() => setOpen(o => !o)}
          aria-label={open ? "Close menu" : "Open menu"}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            {open ? (
              <>
                <line x1="3" y1="3" x2="15" y2="15" stroke="#1a1a1a" strokeWidth="1.8" strokeLinecap="round"/>
                <line x1="15" y1="3" x2="3" y2="15" stroke="#1a1a1a" strokeWidth="1.8" strokeLinecap="round"/>
              </>
            ) : (
              <>
                <line x1="2" y1="4.5"  x2="16" y2="4.5"  stroke="#1a1a1a" strokeWidth="1.8" strokeLinecap="round"/>
                <line x1="2" y1="9"    x2="16" y2="9"    stroke="#1a1a1a" strokeWidth="1.8" strokeLinecap="round"/>
                <line x1="2" y1="13.5" x2="16" y2="13.5" stroke="#1a1a1a" strokeWidth="1.8" strokeLinecap="round"/>
              </>
            )}
          </svg>
        </button>

      </nav>

      {/* MOBILE DROPDOWN */}
      {open && (
        <div className="nav-mobile-menu">
          {NAV_ITEMS.map(({ label, to, href, external }) =>
            external ? (
             <a
  href="/resume.pdf"
  download="Satish-Dandabathula-UIUX-Designer-Resume.pdf"
  className="nav-item"
>
  Resume
</a>
            ) : (
              <Link
                key={label}
                to={to}
                className={"nav-mobile-item" + (location.pathname === to.split("#")[0] ? " active" : "")}
                onClick={close}
              >
                {label}
              </Link>
            )
          )}
        </div>
      )}
    </>
  );
}